import styled from 'styled-components'

export const OrderManagerStyled = styled.div`
  position: relative;
`
